// Mock data for Switch Schools Landing Page

export const heroData = {
  title: "CONFIDENT SCHOOL DECISIONS, BUILT AROUND YOUR CHILD.",
  subtitle: "A 15-minute diagnostic that cuts through the noise — fee projections, tuition data, and honest school comparisons, all in one report.",
  ctaText: "See How It Works",
  ctaPrice: "RM4.99",
  heroImage: "https://customer-assets.emergentagent.com/job_clean-typography-1/artifacts/sr5hx03f_pexels-alex-green-5691834.jpg"
};

export const problemStatements = [
  {
    id: 1,
    question: "The Future Readiness Question",
    description: "Will my child's school prepare them for a world we can't predict?",
    impact: "Parents worry about gaps in curriculum, teaching methods, and real-world skills."
  },
  {
    id: 2,
    question: "The Tuition Paradox",
    description: "Why am I paying for tuition if the school is supposedly 'good enough'?",
    impact: "See what other parents in the same school and grade are really spending on supplementary education."
  },
  {
    id: 3,
    question: "The Fee Blindspot",
    description: "What will this school actually cost me over the next 5 years?",
    impact: "Hidden costs, annual escalations, and tuition spend add up. We show you the real number."
  }
];

export const keyFeatures = [
  {
    id: 1,
    title: "Parent Diagnostic Platform",
    description: "A structured, conversational tool that gathers intelligence about your child's needs, learning style, and your priorities.",
    icon: "MessageSquare"
  },
  {
    id: 2,
    title: "Future Readiness Assessment",
    description: "Questions specifically addressing how well schools prepare children for the unknown future, not just test scores.",
    icon: "Target"
  },
  {
    id: 3,
    title: "5-Year Fee Calculator",
    description: "Projects total school costs over time, including fee escalation and community tuition data.",
    icon: "Calculator"
  },
  {
    id: 4,
    title: "Community Intelligence",
    description: "Aggregated parent feedback on recurring issues: safety, academics, culture, and pastoral care.",
    icon: "Users"
  },
  {
    id: 5,
    title: "Honest School Recommendations",
    description: "Three personalized school matches based on your child's profile, not marketing materials.",
    icon: "Award"
  },
  {
    id: 6,
    title: "Tuition Spend Mapping",
    description: "See real community data on what parents actually spend on supplementary tuition, school by school.",
    icon: "TrendingUp"
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Answer the Diagnostic",
    description: "A warm, conversational questionnaire about your child, their learning style, and what matters most to you.",
    duration: "10-15 minutes"
  },
  {
    step: 2,
    title: "We Analyze the Data",
    description: "Our algorithm matches your child's profile with school data, community intelligence, and future readiness indicators.",
    duration: "Instant"
  },
  {
    step: 3,
    title: "Get Your Report",
    description: "Three honest recommendations, 5-year cost projections, tuition insights, and community flags — delivered as a comprehensive PDF.",
    duration: "Immediate download"
  }
];

export const pricingData = {
  price: "RM4.99",
  description: "One-time payment for your personalized diagnostic report",
  features: [
    "Personalized school recommendations",
    "5-year cost calculator with tuition data",
    "Community intelligence and flags",
    "Honest reviews from real parents",
    "Comprehensive PDF report",
    "Mobile-friendly experience"
  ],
  valueStatement: "Low enough to be impulsive. High enough to signal real value."
};

export const socialProof = {
  parentCount: "500+",
  schoolsCovered: "45+",
  avgSaving: "RM12,000",
  satisfactionRate: "94%"
};
